import { DropStatus, FreeDropNotificationType, FreeDropTheme } from '../enums';
import { THIRTY_MINUTES_MS, TWO_MINUTES_MS } from './utils';
import { FreeDropThemeConfig } from '../models';
import { T } from './translation-keys';

import RedEnvelopeOpenedImage from '../assets/images/free-drop/red-envelope-opened.png';
import EnvelopeSprite from '../assets/images/free-drop/envelope-sprite.png';
import ClosedGiftImage from '../assets/images/free-drop/closed-gift.png';
import PrizeSprite from '../assets/images/free-drop/prize-sprite.png';
import GiftEmptyImage from '../assets/images/free-drop/gift-empty.png';
import EnvelopeGif from '../assets/images/free-drop/envelope-gif.gif';
import PackageGif from '../assets/images/free-drop/package-gif.gif';
import PrizeImage from '../assets/images/free-drop/prize-img.png';

export const FreeDropDropStatusClasses = {
  [DropStatus.Next]: 'next',
  [DropStatus.Upcoming]: 'upcoming',
  [DropStatus.Finished]: 'finished'
};

export const FreeDropDropStatusNames = {
  [DropStatus.Next]: T.NEXT,
  [DropStatus.Upcoming]: T.UPCOMING,
  [DropStatus.Finished]: T.FINISHED
};

// the only place theme images are picked; the sprite frame layout lives next to the theme class in free-drop/style.scss
export const FreeDropThemeConfigs: Record<FreeDropTheme, FreeDropThemeConfig> = {
  [FreeDropTheme.Gift]: {
    className: 'gift-theme',
    announcementGif: PackageGif,
    announcementGifClassName: 'package',
    smallPopupImage: GiftEmptyImage,
    widgetIcon: ClosedGiftImage,
    rewardIcon: PrizeImage,
    dropSprite: PrizeSprite
  },
  [FreeDropTheme.RedEnvelope]: {
    className: 'red-envelope-theme',
    announcementGif: EnvelopeGif,
    announcementGifClassName: 'envelope',
    smallPopupImage: RedEnvelopeOpenedImage,
    // TODO: placeholder until design exports the red envelope widget icon
    widgetIcon: RedEnvelopeOpenedImage,
    // TODO: placeholder until design exports the red envelope reward icon
    rewardIcon: RedEnvelopeOpenedImage,
    dropSprite: EnvelopeSprite
  }
};

// how long the widget stays expanded for a notification
export const FREE_DROP_NOTIFICATION_DURATION = 3_000;

// the widget expands once this long after it shows up
export const FREE_DROP_WIDGET_INTRO_DELAY = 10_000;

// a countdown notification is shown only to a player who is there when its threshold passes
export const FREE_DROP_COUNTDOWN_NOTIFICATION_GRACE = 10_000;

export const FreeDropCountdownNotifications = [
  { type: FreeDropNotificationType.DropIn30Minutes, threshold: THIRTY_MINUTES_MS, message: T.FREE_DROP_30_MINUTES_NOTIFICATION },
  { type: FreeDropNotificationType.DropIn2Minutes, threshold: TWO_MINUTES_MS, message: T.FREE_DROP_2_MINUTES_NOTIFICATION }
];

export const FREE_DROP_WIDGET_POSITION_KEY = 'freeDropWidgetPosition';
